<template>
  <b-container fluid id="start-container">
    <!-- Modal for First time show only -->
    <div v-if="visible & (announcements.length > 0)" class="annoucement">
      <div class="wrapper">
        <div class="close_annoucement" @click="closeAnnouncement">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z" /></svg>
        </div>
        <div v-for="(announcement, index) in announcements" :key="index" class="single-announcement">
          <h2>{{ announcement.title }}</h2>
          <p>{{ announcement.body }}</p>
          <small>{{ formatDate(announcement.updated_at) }}</small>
        </div>
      </div>
    </div>

    <!-- Modal for All Announcements -->
    <div v-if="showAllAnnouncements" class="announcement-modal">
      <div class="wrapper">
        <div class="close_annoucement" @click="closeAllAnnouncements">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z" /></svg>
        </div>
        <div v-for="(announcement, index) in announcements" :key="index" class="single-announcement">
          <h2>{{ announcement.title }}</h2>
          <p>{{ announcement.body }}</p>
          <small>{{ formatDate(announcement.updated_at) }}</small>
        </div>
      </div>
    </div>

    <v-stepper v-model="e1">
      <v-stepper-header>
        <b-row class="stepper-row">
          <b-col cols="11">
            <b-row> </b-row>
          </b-col>
          <b cols="1" class="annoucement_wrapper">
            <img v-if="internet == 'on'" class="internet-logo" src="../assets/on.svg" alt="internet" />
            <img v-if="internet == 'off'" class="internet-logo" src="../assets/off.svg" alt="internet" />
            <img @click="showAllAnnouncementsHandler" class="annoucement-logo" src="../assets/announcement.svg" alt="annoucement" />
          </b>
        </b-row>
      </v-stepper-header>

      <v-stepper-items class="wrapper rebate-wrapper">
        <v-stepper-content step="1">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row" v-if="runupdate">
              <b-col cols="12" sm="12">
                <h2 class="rebate-header">
                  <img class="header-icon" src="../assets/checking.svg" alt="Login" />
                  <span>Downloading presentations</span>
                </h2>
                <p>Please do not close the application while downloading is in progress. If the download fails please logout and restart the application.</p>
                <b-progress variant="secondary" height="2rem" :value="percent" :max="100" animated> </b-progress>
                <p>Downloading presentation {{ nameofdownloadfile }}. {{ filenumber }}/{{ filecount }} presentations successfully downloaded</p>
                <br />
              </b-col>
            </b-row>

            <div v-if="updatecheck">
              <b-row class="user-row">
                <b-col cols="12" sm="10">
                  <h2 class="rebate-header">Manage your presentations</h2>

                  <b-row no-gutters class="mt-3 mb-4">
                    <b-col cols="12">
                      <p class="pr-4">Select one or more presentations based on your certifications to download to your computer.</p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <!-- Buttons for more controls -->
              <div class="button-cont mb-3">
                <b-button type="submit" tabindex="0" size="sm" @click="selectAllRows" class="mmm-button next blacked intro"
                  >Select all
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar blacked" />
                </b-button>

                <b-button type="submit" tabindex="0" size="sm" @click="clearSelected" class="mmm-button next blacked intro"
                  >Clear all
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar blacked" />
                </b-button>
              </div>

              <b-table class="tablealign" :items="items" :fields="fields" :select-mode="selectMode" responsive="sm" ref="selectableTable" selectable @row-selected="onRowSelected">
                <template #cell(selected)="{ rowSelected }">
                  <!-- <p>{{ rowSelected }}</p> -->
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
              </b-table>

              <div class="button-cont mb-3">
                <b-button type="submit" tabindex="0" @click="savechanges" class="mmm-button next intro"
                  >Save changes
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar" />
                </b-button>
                <b-button v-if="showskip" type="submit" tabindex="0" @click="skipfornow" class="mmm-button next intro"
                  >Skip for now
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar" />
                </b-button>
              </div>
            </div>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </b-container>
</template>

<script>
import { getHeader } from "../headers.js";
import moment from "moment";
import { required, email } from "vuelidate/lib/validators";
import { useSessionStore } from "../session";

export default {
  props: ["userProfile"],

  data() {
    return {
      announcements: [],
      visible: true,
      showAllAnnouncements: false,
      downloads: null,
      token: null,
      sessionStore: null,
      instructorData: [],
      fields: ["selected", "course_name", "country", "duration", "language", "code", "expiry", "status"],
      items: [],
      selectMode: "multi",
      selected: [],
      storedcert: [],
      e1: 1,
      userCredentials: {
        username: "",
        password: "",
        device_name: "electron",
      },
      userPin: "",
      internet: "off",
      error: false,
      pinerror: false,
      pinerrorMsg: "",
      viewable: false,
      errorMsg: "",
      percent: "",
      nameofdownloadfile: "",
      runpercent: "",
      files: "",
      serveurl: "",
      extractionid: "",
      todownload: {},
      filecount: 0,
      filenumber: 0,
      progress: 0,
      loggedin: false,
      pinin: false,
      updatecheck: false,
      runupdate: false,
      showskip: false,
      optionstep: 6,
      daycount: [
        {
          value: "",
          text: "",
        },
      ],
      languages: [
        {
          value: "",
          text: "",
        },
      ],
      countries: [
        {
          value: "",
          text: "",
        },
      ],
      province: null,
      duration: null,
      country: null,
      provinces: {},
      durations: {},
      countires: {},
      language: null,
      // languages: [
      //   { text: "English", value: "en" },
      //   { text: "French", value: "fr" },
      // ],
      instructor: {},
      current: {
        topic: {
          name: "",
          icon: "",
          id: "",
          courses: [
            {
              id: "",
              icon: "",
              name: "",
              certdate: "",
              options: [
                {
                  id: "",
                  course_id: "",
                  code: "",
                  day: "",
                  country: "",
                  states: "",
                  language: "",
                  active: "",
                  presentation: {
                    id: "",
                    option_id: "",
                    filename: "",
                    fivepoint_status: "",
                    activated: "",
                  },
                },
              ],
            },
          ],
        },
      },
      selected: {
        topicid: "",
        courseid: "",
        presid: "",
        code: "",
        day: "",
        country: "",
        state: "",
        language: "",
        filename: "",
        paramduration: "",
        paramcountry: "",
        paramlanguage: "",
      },
    };
  },
  validations: {
    userCredentials: {
      username: {
        required,
        email,
      },
      password: {
        required,
      },
    },
    userPin: {
      required,
    },
  },

  mounted() {
    let vm = this;
    vm.serve().then(function () {});

    this.sessionStore = useSessionStore();
    this.sessionStore.loadJWT().then((data) => {
      this.token = data;
    });
  },
  created() {
    let vm = this;
    this.sessionStore = useSessionStore();

    vm.e1 = 1;
    vm.updatecheck = true;

    if (!window.navigator.onLine) {
      vm.skipfornow();
    }

    this.sessionStore
      .loadInstructor()
      .then((data) => {
        if (data) {
          vm.storedcert = data.data.storedcert;
          this.storedcert = data.data.storedcert; // Update storedcert if data is returned
          this.instructorData = data.data; // Update storedcert if data is returned

          this.sessionStore.loadDownloads().then((downloads) => {
            for (const [key, course] of Object.entries(data.data.certifications)) {
              for (const [key, opt] of Object.entries(course.courses)) {
                for (const [key, element] of Object.entries(opt.options)) {
                  var status = "";
                  if (downloads != null) {
                    vm.showskip = true;
                    if (data.stackcheck) {
                      var statuscheck = data.stackcheck.options.find((c) => c.id === element.id);
                    }
                    var downloadcheck = downloads.find((c) => c.optid === element.id);
                  }

                  if (downloadcheck) {
                    status = "Downloaded";
                    if (statuscheck) {
                      status = "Update Pending";
                    }
                  }

                  if (element.paramcountry.name == "Canada") {
                    var countryname = element.paramcountry.name + " (" + element.states + ")";
                  } else {
                    countryname = element.paramcountry.name;
                  }

                  vm.items.push({
                    isActive: true,
                    topic_id: course.id,
                    course_name: opt.name,
                    country: countryname,
                    duration: element.paramduration.name,
                    language: element.paramlanguage.name,
                    presentation: element.presentation.filename,
                    presid: element.presentation.id,
                    code: element.code,
                    fullnode: course,
                    // expiry: moment(element.certificate.expirydate).format("MMM DD YYYY"),
                    expiry: moment(element.certificate.expirydate).format("MMM DD YYYY"),
                    status: status,
                    optid: element.id,
                    courseid: opt.id,
                  });
                }
              }
              // });
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching instructor data:", error);
      });

    this.fetchAnnouncements();
  },

  methods: {
    async fetchAnnouncements() {
      try {
        const apiKey = await this.sessionStore.loadJWT();

        // Make the API call
        const response = await this.axios.get("https://instructor.branton.io/api/announcements", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
          },
        });

        const fetchedAnnouncements = response.data.data;

        // Filter out already seen announcements
        const seenAnnouncements = await this.sessionStore.loadAnnouncements();
        const newAnnouncements = fetchedAnnouncements.filter((announcement) => !seenAnnouncements.some((seen) => seen.id === announcement.id));

        // Update announcements list to display and store new ones in IndexedDB
        this.announcements = newAnnouncements;
        await this.sessionStore.setAnnouncements(fetchedAnnouncements);
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    },

    closeAnnouncement() {
      this.visible = false;
    },

    async showAllAnnouncementsHandler() {
      this.showAllAnnouncements = true;
      this.announcements = await this.sessionStore.loadAnnouncements(); // Load all announcements
    },

    closeAllAnnouncements() {
      this.showAllAnnouncements = false;
      this.visible = false;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      }).format(date);
    },

    setSelectedItemsInTable(items) {
      this.sessionStore.loadDownloads().then((data) => {
        if (data) {
          var downloads = data;
          for (const [key, download] of Object.entries(downloads)) {
            var itemindex = items.findIndex((item) => {
              return item.optid == download.optid;
            });

            // console.log(`itemindex`, itemindex);
            if (itemindex !== -1) {
              this.$refs.selectableTable.selectRow(itemindex);
            }
          }
        }
      });
    },

    updateElement(topicId, courseId, optionId, fullnode) {
      let vm = this;

      // const topicIndex = Object.values(vm.storedcert).findIndex(el => el.id === topicId);
      let topic = Object.entries(vm.storedcert).find(([key, value]) => value.id === topicId);
      if (topic === undefined) {
        vm.storedcert.push(fullnode);
        return;
      }
      vm.storedcert[topic[0]].icon = fullnode.icon;

      let course = Object.entries(vm.storedcert[topic[0]].courses).find(([key, value]) => value.id === courseId);
      if (course === undefined) {
        vm.storedcert[topic[0]].courses = fullnode.courses;
        return;
      }
      vm.storedcert[topic[0]].courses[course[0]].icon = fullnode.courses[course[0]].icon;

      let option = Object.entries(vm.storedcert[topic[0]].courses[course[0]].options).find(([key, value]) => value.id === optionId);
      if (option === undefined) {
        vm.storedcert[topic[0]].courses[course[0]].options = fullnode.courses[course[0].options];
        return;
      }

      // console.log(topic);
      // console.log(course);
      // console.log(option);
      vm.storedcert[topic[0]].courses[course[0]].options[option[0]] = fullnode.courses[course[0]].options[option[0]];
    },

    onRowSelected(items) {
      let vm = this;

      this.selected = items;

      vm.selected.forEach((selected) => {
        //update the storedcert data here
        vm.updateElement(selected.topic_id, selected.courseid, selected.optid, selected.fullnode);
      });
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },

    skipfornow: function () {
      this.$router.push({ path: "start" });
    },

    goauth: function () {
      this.$router.push({ path: "auth" });
    },

    processupdate: function () {
      let vm = this;
      let userData = this.instructorData;
      let dom = this.api + "/api/requeststackdesktop";

      vm.runupdate = true;

      var config = {
        method: "post",
        url: dom,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.token}`,
        },
        data: userData,
      };

      vm.axios(config).then(function (response) {
        // console.log(response);

        vm.updatecheck = false;
        vm.runupdate = true;

        // console.log(` vm.selected: `, vm.selected);

        let todownload = [];
        todownload.push("extraction.zip");
        vm.selected.forEach((selected) => {
          if (selected.status == "" || selected.status == "Update Pending") {
            // console.log(selected.status);
            var file = selected.presentation.split(".").slice(0, -1).join(".");
            todownload.push(file + ".zip");
          }
        });

        vm.filecount = todownload.length;
        // console.log(todownload, 'The total file count');

        vm.update(todownload).then(function () {
          vm.runpercent = setInterval(vm.percentstatus, 500);
        });
      });
    },

    savechanges: function () {
      let vm = this;

      let data = this.instructorData;
      data.storedcert = vm.storedcert;

      vm.processupdate();
    },

    async percentstatus() {
      try {
        let vm = this;
        let percent = await window.file.status();
        // console.log(percent);
        vm.percent = percent[0];
        vm.filenumber = percent[1];
        vm.nameofdownloadfile = percent[2].fileName.split(".").slice(0, -1).join(".");
      } catch (e) {
        // console.log(`Failed to save the file ${e}!`);
      }
    },

    async update(url) {
      try {
        //We can process here the correct URL path for the ZIP download as well as credential authentication via API
        await window.file.runme(url);
      } catch (e) {
        // console.log(`Failed to save the file ${e}!`);
      }
    },

    async extraction(file, location) {
      try {
        let vm = this;
        await window.file.unzip(file, location);
        var downloads = [];
        vm.selected.forEach((selected) => {
          downloads.push({
            courseid: selected.code,
            optid: selected.optid,
            presid: selected.presid,
            filename: selected.presentation,
          });

          //update the storedcert data here
          // vm.updateElement(selected.topic_id, selected.courseid, selected.optid, selected.fullnode);
        });

        //trigger an getInstructor update after everything is done

        this.sessionStore.setDownloads(downloads);

        vm.goauth();
        vm.updatecheck = true;
        vm.runupdate = false;
      } catch (e) {
        // console.log(`Failed to unzip the file ${e}!`);
      }
    },
    async serve() {
      try {
        let vm = this;
        let userPath = await window.file.userPath();
        vm.serveurl = userPath;
      } catch (e) {
        // console.log(`Failed to serve the file ${e}!`);
      }
    },
  },
  beforeCreate: async function () {
    let vm = this;
    this.sessionStore = useSessionStore();

    this.sessionStore.loadJWT().then((data) => {
      if (data && data.trim() !== "") {
        // console.log("JWT is present, setting isLoggedIn to true");
        vm.$root.isLoggedIn = true; // User is logged in
      } else {
        // console.log("No JWT found, setting isLoggedIn to false");
        vm.$root.isLoggedIn = false; // User is not logged in
      }
    });
  },
  watch: {
    percent: function (value) {},
    filenumber: function (value) {
      // Whenever the prop "name" changes, then we will console log its value.
      if (value == this.filecount) {
        // console.log(value, this.filecount, 'filecount filenumber watch');
        clearInterval(this.runpercent);
        this.extraction("extraction.zip", "assets");
      }

      // if (value == 0) {
      // vm.updatecheck = true;
      //   vm.runupdate = false;
      // }
    },

    items(newItems) {
      this.setSelectedItemsInTable(newItems);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

// .annoucement_wrapper {
//   width: 100%;
//   display: flex;
//   justify-content: flex-end;
//   padding-right: 20px;
// }

.annoucement-logo {
  width: 22px;
  margin-left: 10px;
  cursor: pointer;
}
.button-cont {
  display: flex;
}

.tablealign {
  // text-transform: none;
  text-align: left !important;
}

.annoucement,
.announcement-modal {
  position: fixed;
  width: 100%;
  height: 90%;
  top: 10%;
  left: 0;
  background-color: rgba(black, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.5s ease;
  z-index: 99;
  .wrapper {
    text-align: start;
    padding: 60px 40px 40px 40px;
    background-color: #fff;
    position: relative;
    width: 700px;
    .single-announcement {
      border-bottom: 1px solid black;
      margin-bottom: 20px;
      &:last-child {
        border-bottom: unset;
      }
      h2 {
        font-size: 25px;
        margin: 0;
      }
      p {
        margin: 0;
        margin-bottom: 5px;
      }
      small {
        display: block;
        color: black;
        margin-bottom: 20px;
        font-size: 13px;
      }
    }
    .close_annoucement {
      position: absolute;
      right: 20px;
      top: 20px;
      svg {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }
}
.announcement-leave-active {
  opacity: 0;
}
</style>
